import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Car, Heart, Clock, ShoppingCart, X, ChevronRight } from 'lucide-react';

export default function RegisterCTA({ variant = 'banner' }) {
  const { token } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('cta_dismissed') === '1');

  if (token || dismissed) return null;

  const dismiss = () => { setDismissed(true); sessionStorage.setItem('cta_dismissed', '1'); };

  if (variant === 'inline') {
    return (
      <div data-testid="register-cta-inline" style={{
        background: 'linear-gradient(135deg, rgba(255,46,46,0.08) 0%, rgba(255,46,46,0.02) 100%)',
        border: '1px solid rgba(255,46,46,0.15)',
        padding: '1rem 1.25rem',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '0.75rem',
        margin: '1rem 0',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}>
        <Heart size={20} color="var(--primary)" style={{ flexShrink: 0 }} />
        <div style={{ flex: '1 1 200px', minWidth: 0 }}>
          <span style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 500 }}>
            Melde dich an für Wunschliste, Fahrzeug-Profil & persönliche Empfehlungen
          </span>
        </div>
        <Link to="/auth" data-testid="register-cta-inline-btn"
          style={{ background: 'var(--primary)', color: '#fff', padding: '6px 16px', textDecoration: 'none', fontWeight: 600, fontSize: '0.8rem', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4 }}>
          Kostenlos registrieren <ChevronRight size={14} />
        </Link>
      </div>
    );
  }

  // Full banner
  return (
    <div data-testid="register-cta-banner" style={{
      background: 'linear-gradient(135deg, rgba(255,46,46,0.1) 0%, rgba(255,46,46,0.03) 100%)',
      border: '1px solid rgba(255,46,46,0.12)',
      padding: '2rem',
      position: 'relative',
      margin: '2rem 0',
    }}>
      <button onClick={dismiss} style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', color: 'var(--fg-muted)', cursor: 'pointer' }}>
        <X size={16} />
      </button>
      <h3 style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.75rem', fontFamily: 'var(--font-heading)' }}>
        Dein persönliches <span style={{ color: 'var(--primary)' }}>Performance-Erlebnis</span>
      </h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.25rem' }}>
        {[
          { icon: <Car size={18} />, text: 'Fahrzeug hinterlegen & passende Teile finden' },
          { icon: <Heart size={18} />, text: 'Wunschliste & Merkliste für deine Lieblingsteile' },
          { icon: <ShoppingCart size={18} />, text: 'Warenkorb speichern & auf allen Geraeten nutzen' },
          { icon: <Clock size={18} />, text: 'Suchverlauf & zuletzt angesehene Produkte' },
        ].map((f, i) => (
          <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <span style={{ color: 'var(--primary)', flexShrink: 0, marginTop: 2 }}>{f.icon}</span>
            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem', lineHeight: 1.4 }}>{f.text}</span>
          </div>
        ))}
      </div>
      <Link to="/auth" data-testid="register-cta-btn"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--primary)', color: '#fff', padding: '10px 24px', textDecoration: 'none', fontWeight: 700, fontSize: '0.9rem', letterSpacing: '0.02em' }}>
        Kostenlos Account erstellen <ChevronRight size={16} />
      </Link>
    </div>
  );
}
